import CustomModal from "../../../components/CustomModal";
import React from "react";
import FormLabel from "../../../components/form/FormLabel";
import {cloneDeep} from "lodash";
import CustomIcon from "../../../components/CustomIcon";
import {FOCUS_DISPLAY_TYPE, FOCUS_TYPE_OPTIONS} from "../enums";
import {savedPresets} from "../constants";

const FocusItemsChooserModal = ({showModal, setShowModal, setFocusedType}) => {


  return (
    <CustomModal
      title="Add Focus Item"
      bodyClasses="max-w-md"
      showModal={showModal}
      setShowModal={setShowModal}
    >
      <FormLabel label="Choose Focus Item type"/>
      {FOCUS_TYPE_OPTIONS.map((o) => (
        <div
          key={`${o.value}-focusItem-type`}
          className="flex items-center px-4 py-3 mb-2 border cursor-pointer rounded-md space-x-2 hover:bg-secondary-100"
          onClick={() => {
            setFocusedType({
              ...cloneDeep(initialFocusItem),
              type: o.value, extras: savedPresets[0].values
            });
            setShowModal(undefined);
          }}
        >
          <CustomIcon icon={o.icon} size="xl"/>
          <div className="text-md">{o.label}</div>
        </div>
      ))}
    </CustomModal>
  );
};

export default FocusItemsChooserModal;

const initialFocusItem = {
  title: '',
  type: '',
  display_type: FOCUS_DISPLAY_TYPE[0].value,
  items: [
    {title: '', sub_title: '', value: '', default: '', image_url: '', image_url_web: ''}
  ]
};
